import classNames from 'classnames';
import { ReactNode } from 'react';

import { Button, ButtonVariant, Icon, IconName, Typography } from '../';

import './ClickPlace.scss';

export interface ClickPlaceData<T = string> {
  label: ReactNode;
  value: T;
  icon: IconName;
  disabled?: boolean;
}

interface Props<T> {
  data: Array<ClickPlaceData<T>>;
  onClick: (value: T) => void;
  className?: string;
}

export const ClickPlace = <T,>({ data, onClick, className }: Props<T>) => {
  return (
    <div className={classNames('custom-click-place', className)}>
      {data.map(({ icon, label, value, disabled = false }) => (
        <Button
          variant={ButtonVariant.ICON_GHOST}
          key={String(value)}
          onClick={(): void => onClick(value)}
          disabled={disabled}
        >
          <div className="custom-click-place__item">
            <Icon name={icon} width={48} height={48} className="custom-click-place__icon" />
            <Typography textCenter className="custom-click-place__text">
              {label}
            </Typography>
          </div>
        </Button>
      ))}
    </div>
  );
};
